var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72089 0.000529818C4.80894 0.000529818 0.827148 3.98327 0.827148 8.89585C0.827148 10.9067 1.58177 12.6977 2.61882 14.2512C4.42644 16.9556 9.72057 24.3765 9.72057 24.3765C9.72057 24.3763 15.017 16.9548 16.8239 14.2506C17.861 12.6975 18.6162 10.9067 18.6162 8.89532C18.616 3.98274 14.6337 0 9.72089 0V0.000529818ZM9.72089 12.4857C7.73905 12.4857 6.13256 10.8781 6.13256 8.89548C6.13256 6.9128 7.73947 5.30568 9.72089 5.30568C11.7036 5.30568 13.3111 6.9128 13.3111 8.89548C13.3111 10.8782 11.7035 12.4857 9.72089 12.4857Z",
    fill: "#0F5671"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c10d2869ba96a108845ea7fa809bdc5b.svg";
export { ForwardRef as ReactComponent };